import * as t from './action_types';
import * as api from '../../api/store/actions';
import { SELECT_MODES } from '../../table/table-constants';
const INITIAL_STATE = {
    users: null,
    allUsers: null,
    isLoadingUsers: false,
    isLoadingAllUsers: false,
    stagedEdits: {},
    validationErrors: null,
    detailMode: null,
    validatedPaths: [],
    selectedUserIds: [],
    filters: {},
    templates: {},
    templatesLoading: false,
    activeAuthSite: null,
    userDevices: [],
    userHistory: [],
    isLoadingUserHistory: false,
    selectMode: SELECT_MODES.SINGLE,
    bulkApplyPaths: [],
};

const users = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case t.RESET_USER_DATA:
            return {
                ...INITIAL_STATE,
            };
        case t.SET_ACTIVE_AUTH_SITE: {
            const { activeAuthSite } = action.payload;
            return {
                ...state,
                activeAuthSite,
            };
        }
        case t.SET_USER_CONFIG_TEMPLATES: {
            const { templates } = action.payload;
            return {
                ...state,
                templates,
                templatesLoading: false,
            };
        }
        case t.SET_TEMPLATE_LIST_IS_LOADING: {
            const { isLoading } = action.payload;
            return {
                ...state,
                templatesLoading: isLoading,
            };
        }
        case api.API_START: {
            if (action.payload.label === t.FETCH_USER_LIST) {
                return {
                    ...state,
                    isLoadingUsers: true,
                };
            }
            if (action.payload.label === t.FETCH_ALL_USER_LIST) {
                return {
                    ...state,
                    isLoadingAllUsers: true,
                };
            }
        }
        case api.API_END: {
            if (action.payload.label === t.FETCH_USER_LIST) {
                return {
                    ...state,
                    isLoadingUsers: false,
                };
            }
            if (action.payload.label === t.FETCH_ALL_USER_LIST) {
                return {
                    ...state,
                    isLoadingAllUsers: false,
                };
            }
        }
        case t.SET_STAGED_EDITS: {
            const { data = {} } = action.payload;
            return {
                ...state,
                stagedEdits: { ...data },
            };
        }
        case t.CLEAR_STAGED_EDITS:
            return {
                ...state,
                stagedEdits: {},
            };
        case t.SET_USER_DEVICES: {
            return {
                ...state,
                userDevices: action.payload.userDevices || [],
            };
        }
        case t.CLEAR_USER_DEVICES:
            return {
                ...state,
                userDevices: [],
            };
        case t.SET_USER_HISTORY: {
            return {
                ...state,
                userHistory: action.payload.userHistory || [],
            };
        }
        case t.CLEAR_USER_HISTORY:
            return {
                ...state,
                userHistory: [],
            };
        case t.SET_USER_HISTORY_IS_LOADING:
            return {
                ...state,
                isLoadingUserHistory: !!action.payload.isLoading,
            };
        case t.SET_DETAIL_MODE:
            return {
                ...state,
                detailMode: action.payload.mode,
            };
        case t.SET_VALIDATION_ERRORS:
            return {
                ...state,
                validationErrors: action.payload.errors,
            };
        case t.CLEAR_VALIDATION_ERRORS:
            return {
                ...state,
                validationErrors: null,
            };
        case t.SET_VALIDATED_PATHS:
            return {
                ...state,
                validatedPaths: action.payload.validatedPaths,
            };
        case t.UPDATE_USER_DETAILS: {
            const { data = [] } = action.payload;
            const { users = [] } = state;
            // make new array, replace in same position
            const updatedUsers = users.map((u) => {
                const updated = data.find((updated) => updated.eUserId === u.eUserId);
                return updated ?? u;
                //u.eUserId === data.eUserId ? data : u
            });
            return {
                ...state,
                users: updatedUsers,
            };
        }
        case t.ADD_USER_DETAILS: {
            const { data = {} } = action.payload;
            const { users = [] } = state;
            return {
                ...state,
                users: [data, ...users],
            };
        }
        case t.SET_USER_LIST: {
            return {
                ...state,
                users: action.payload.data,
                isLoadingUsers: false,
            };
        }
        case t.SET_ALL_USER_LIST: {
            return {
                ...state,
                allUsers: action.payload.data,
                isLoadingAllUsers: false,
            };
        }
        case t.SET_USER_FILTERS:
            return {
                ...state,
                filters: action.payload.filters,
            };
        case t.SET_SELECT_MODE:
            return {
                ...state,
                selectMode: action.payload.selectMode,
            };
        case t.SET_BULK_APPLY_PATHS:
            return {
                ...state,
                bulkApplyPaths: action.payload.bulkApplyPaths,
            };
        case t.SET_IS_LOADING: {
            const { isLoading } = action.payload;
            return {
                ...state,
                isLoading,
            };
        }
        case t.SET_IS_SAVING: {
            const { isSaving } = action.payload;
            return {
                ...state,
                isSaving,
            };
        }
        case t.SELECT_USER: {
            const { eUserId } = action.payload;
            const { selectedUserIds = [] } = state;
            // shouldn't be necesssary but prevent it from being in the array twice
            const newSelectedUserIds = selectedUserIds.filter(
                (existingSelectedeUserId) => existingSelectedeUserId !== eUserId
            );
            newSelectedUserIds.push(eUserId);
            return {
                ...state,
                selectedUserIds: newSelectedUserIds,
            };
        }
        case t.UNSELECT_USER: {
            const { eUserId } = action.payload;
            const { selectedUserIds = [] } = state;
            const newSelectedUserIds = selectedUserIds.filter(
                (existingSelectedeUserId) => existingSelectedeUserId !== eUserId
            );
            return {
                ...state,
                selectedUserIds: newSelectedUserIds,
            };
        }
        case t.SELECT_ALL_USERS: {
            const selectedUserIds = state.users.map((s) => s.eUserId);
            return {
                ...state,
                selectedUserIds,
            };
        }
        case t.UNSELECT_ALL_USERS: {
            return {
                ...state,
                selectedUserIds: [],
            };
        }

        default:
            return state;
    }
};

export default users;
